import { Form } from "reactstrap";
import { Btn, P } from "../../../../../AbstractElements";
import { productGalleryData } from "../../../../../Data/Applications/ECommerce/Product";
import { ActiveCallbackProp } from "../../../../../Types/ECommerce.type";
import CommonFileUpload from "../../../../../Utils/CommonComponents/CommonFileUpload";
import DashboardSvgIcon from "../../../../../Utils/CommonComponents/DashboardSvgIcon";

export default function ProductGallery({ activeCallBack }: ActiveCallbackProp) {
  return (
    <div className="sidebar-body">
      {productGalleryData.map((item) => (
        <div className="product-upload" key={item.id}>
          <P>{item.title} </P>
          <Form>
            <CommonFileUpload />
          </Form>
        </div>
      ))}
      <div className="product-buttons">
        <Btn color="transparent" className="me-1" onClick={() => activeCallBack(1)}>
          <div className="d-flex align-items-center gap-sm-2 gap-1">
            <DashboardSvgIcon iconId="back-arrow" /> {"Previous"}
          </div>
        </Btn>
        <Btn color="transparent" onClick={() => activeCallBack(3)}>
          <div className="d-flex align-items-center gap-sm-2 gap-1">
            <DashboardSvgIcon iconId="front-arrow" /> {"Next"}
          </div>
        </Btn>
      </div>
    </div>
  );
}
